export const types = {
  ADULT: 'AD',
  CHILD: 'CH',
  SENIOR: 'SNR',
  YOUTH: 'YTH',
  INFANT: 'IFIA',
  SEATED_INFANT: 'IFWS',
  DOG: 'DOG',
  AD: 'ADULT',
  CH: 'CHILD',
  IFIA: 'INFANT',
  IFWS: 'SEATED_INFANT',
  COMPANION: 'COMP',
  NO_WHEELCHAIR_COMPANION: 'NWC',
  WHEELCHAIR: 'WC',
  INFANT_IN_ARMS: 'IFIA',
  INFANT_WITH_SEAT: 'IFWS',
  NO_HANDICAP: 'NH',
  INFANT_ONLY: 'IFON',
  EVAC: 'EVAC'
};

export const passengerTypes = {
  [types.ADULT]: 'adult',
  [types.CHILD]: 'child',
  [types.SENIOR]: 'senior',
  [types.YOUTH]: 'youth',
  [types.INFANT]: 'infantInArms',
  [types.SEATED_INFANT]: 'seatedInfant',
  [types.DOG]: 'dog',
  [types.AD]: 'adult',
  [types.CH]: 'child',
  [types.IFIA]: 'infantInArms',
  [types.IFWS]: 'seatedInfant'
};
